import { handleDecrypt, handleEncrypt } from "../common/utils/react-ec-utils";

export function getCookie(name: string): any {

  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  if (!match) return null;

  const encodedValue = match[1] as string;
  const encryptedValue = encodedValue;
  const decryptedValue = handleDecrypt(encryptedValue);

  try {
    return JSON.parse(decryptedValue);
  } catch {
    return decryptedValue;
  }
}


export function setCookie(name: string, value: any, days: number = 7) {
  const jsonString = typeof value === 'string' ? value : JSON.stringify(value);
  const encryptedValue = handleEncrypt(jsonString);
  const encodedValue = encryptedValue;

  let cookieString = `${name}=${encodedValue}; path=/`;
  if (days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    cookieString += `; expires=${expires}`;
  }

  document.cookie = cookieString;
}

export function deleteCookie(name: string) {
  document.cookie = `${name}=; Max-Age=0; path=/`;
}